import dxDataGrid from 'devextreme/ui/data_grid';

export function registerColumnChooserSortingModule() {
	(<any>dxDataGrid).registerModule('columnChooserSorting', {
		extenders: {
			controllers: {
				columns: {
					getChooserColumns: function (loadAllColumns) {
						const result = this.callBase(loadAllColumns);
						result.sort(function (column1, column2) {
							return column1.caption?.localeCompare(column2.caption) ?? -1;
						});
						return result;
					},
				},
			},
		},
	});
}
